import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { RootState } from '../app/store';

function PrivateRoute({ children }: { children: JSX.Element }) {
  const loggedIn    = useSelector((state: RootState) => state.session.loggedIn);
  const currentUser = useSelector((state: RootState) => state.session.currentUser);
  const location    = useLocation();

  if (!loggedIn || !currentUser) {
    return <Navigate to="/auth/sign_in" state={{ from: location }} replace />;
  }

  return children;
}

export default PrivateRoute;
